import { RootState } from '../rootReducer';

export const selectCode = (state: RootState) => state.discount.discount.code;
export const selectDiscount = (state: RootState) => state.discount.discount.discount;
